import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ModalService } from '../../../../core/services/modal.service';
import { ThemeService } from '../../../../core/services/theme.service';
import { EnvironmentService } from '../../../../core/services/environment.service';
import { UrlService } from '../../../../core/services/url.service';
import { LoginModalComponent } from '../../../../shared/components/modal/login-modal/login-modal.component';

@Component({
  selector: 'app-liens',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './liens.component.html',
  styleUrls: ['./liens.component.scss'],
})
export class LiensComponent {
  constructor(
    private modalService: ModalService,
    private themeService: ThemeService,
    private environmentService: EnvironmentService,
    private urlService: UrlService,
  ) {}

  /** Lien vers la page d'accueil (avec préfixe pays si présent) */
  prefixUrl(): string {
    return this.urlService.buildUrl('/home');
  }

  getProductName(): string {
    return this.themeService.getProductName();
  }

  get appStoreUrl(): string {
    return this.environmentService.getAppStoreUrl();
  }

  get playStoreUrl(): string {
    return this.environmentService.getPlayStoreUrl();
  }

  openLoginModal(): void {
    this.modalService.open({
      component: LoginModalComponent,
      width: '500px',
      title: 'Connexion',
      closable: true,
    });
  }
}
